import { useEffect, useState } from "react";
import { mutate } from "swr";
import { apiSaveResults } from "../../api";

const GetResults = ({ loggedUser, serverData, totalScore }) => {
  console.log(loggedUser, serverData, totalScore);
  const [trigger, setTrigger] = useState(null);
  const [success, setSuccess] = useState(false);
  useEffect(() => {
    if (trigger === null) {
      setTrigger(true);
    }
  }, []);

  const sendDataToServer = async () => {
    if(totalScore!==null && !isNaN(totalScore)){
    try {
      const data = await apiSaveResults(loggedUser, totalScore, serverData);
      console.log('Server response:', data);
      
       if(data.success){
        setSuccess(true)
       } else {
        console.error('Server returned success=false:', data);
        throw new Error(data.message || "Failed to send data to server");
       }
       
      if (!data.success) {
        throw new Error(data.message || "Failed to send data to server");
        
      }

      console.log("Data sent successfully");
    } catch (error) {
      console.error("Error sending data to server:", error.message);
      console.error("Full error:", error);
    }
  }}

  useEffect(() => {
    if (trigger === true && totalScore !== null && !isNaN(totalScore)) {
      mutate('key-for-mutate', sendDataToServer, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        errorRetryCount: 3,
        errorRetryInterval: 1000,
        onSuccess: () => {
          setTrigger(null);
          setSuccess(true);
        },
      })
    }
  }, [loggedUser, serverData, totalScore,trigger]);

  return (
    success===true?(
      <div style={{ textAlign: "center" }}>
       <p style={{ color: "#ffffff", fontWeight: "bold", fontSize: "18px", textShadow: "0 0 10px rgba(255, 255, 255, 0.6)" }}>Το αποτέλεσμα της εξέτασης καταχωρηθηκε επιτυχως</p>
      </div>
    ):(
      <span className="loader">Αποστολή αποτελεσμάτων στον server</span>
    )
    
  );
};

GetResults.defaultProps = {
  loggedUser: null,
  serverData: null,
  totalScore: null,
};

export default GetResults
